import React from "react";
import {
    TabPanels,
    Tabs,
    TabPanel,
    TabList,
    Menu,
    MenuButton,
    MenuList,
    MenuItem,
    Button,
    HStack,
} from "@chakra-ui/react";
import { Container, Heading } from "components";
import Clients from "./clients";
import { useUser } from "hooks";
import Distributors from "./distributors";
import Financial from "./financial";
import Withdraws from "./withdraws";
import Promotion from "./promotion";
import Product from "./product";
import PixRainCampaign from "./pix_rain_campaign";
import Statement from "./statement";
import PurchaseRating from "./distributors/purchaseRating";
import PurchaseSaleDetails from "./distributors/purchaseSaleDetails";
import BestReferral from "./best-referral";
import StockReports from "./stock";

export default function Reports() {
    const { data } = useUser();

    const userHasRole = (role) =>
        !!(data?.roles?.includes(role) || data?.roles?.includes("*"));

    const tabs = [
        { role: "reports_consultants", label: "Clientes", content: <Clients /> },
        {
            role: "reports_distributors",
            label: "Relatórios Núcleos",
            submenu: [
                { label: "Núcleos", content: <Distributors /> },
                { label: "Classificação de Compras", content: <PurchaseRating /> },
                { label: "Classificação de Compras X Vendas", content: <PurchaseSaleDetails /> },
            ],
        },
        { role: "reports_products", label: "Produtos", content: <Product /> },
        { role: "reports_financial", label: "Financeiro", content: <Financial /> },
        { role: "reports_withdraws", label: "Saques", content: <Withdraws /> },

        {
            role: "reports_promotion",
            label: "Promoções",
            submenu: [
                /*{ label: "Promoção", content: <Promotion />  },*/
                /*{ label: "Promoção Chuva de Pix", content: <PixRainCampaign /> },*/
                { label: "Top 10 Recrutadores", content: <BestReferral /> },
            ],
        },

        { role: "reports_statement", label: "Recebimentos", content: <Statement /> },
        { role: "reports_stock",     label: "Estoque",      content: <StockReports /> },
    ];

    const visibleTabs = tabs.filter((t) => userHasRole(t.role));

    const [activeIndex, setActiveIndex] = React.useState(0);
    const [submenuSelection, setSubmenuSelection] = React.useState({});

    const handleSelectSubmenu = (tabIndex, itemIndex) => {
        setSubmenuSelection((s) => ({ ...s, [tabIndex]: itemIndex }));
        setActiveIndex(tabIndex);
    };

    return (
        <Container mt={10}>
            <Heading title="Relatórios" />

            <Tabs index={activeIndex} onChange={(i) => setActiveIndex(i)} isLazy align="center">
                <TabList>
                    {visibleTabs.map((tab, i) => {
                        if (tab.submenu) {
                            // Criamos uma "fake tab" com HStack, não Tab do Chakra
                            return (
                                <HStack key={tab.role} spacing={2}>
                                    <Menu isLazy>
                                        <MenuButton
                                            as={Button}
                                            variant="ghost"
                                            px={4}
                                            _hover={{ bg: "gray.500" }}
                                            _active={{ bg: "gray.500" }}
                                        >
                                            {tab.label} ▾
                                        </MenuButton>
                                        <MenuList zIndex="dropdown">
                                            {tab.submenu.map((item, idx) => (
                                                <MenuItem key={idx} onClick={() => handleSelectSubmenu(i, idx)}>
                                                    {item.label}
                                                </MenuItem>
                                            ))}
                                        </MenuList>
                                    </Menu>
                                </HStack>
                            );
                        }

                        // Abas normais
                        return <Button key={tab.role} variant="ghost" onClick={() => setActiveIndex(i)}>{tab.label}</Button>;
                    })}
                </TabList>

                <TabPanels>
                    {visibleTabs.map((tab, i) => {
                        if (tab.submenu) {
                            const selectedIdx = submenuSelection[i] ?? null;
                            const SelectedContent = selectedIdx !== null ? tab.submenu[selectedIdx]?.content : null;
                            return <TabPanel key={tab.role}>{SelectedContent}</TabPanel>;
                        }
                        return <TabPanel key={tab.role}>{tab.content}</TabPanel>;
                    })}
                </TabPanels>
            </Tabs>
        </Container>
    );
}
